import { ChannelUserWorkspace, Maybe } from '@/types/generated/graphql';

export function sortChannelsByDefault(
  channels: Maybe<Maybe<ChannelUserWorkspace>[]> | undefined
): Maybe<ChannelUserWorkspace>[] {
  if (!channels) return [];

  return [...channels].sort((a, b) => Number(!!b?.isDefault) - Number(!!a?.isDefault));
}
